var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"f-section"},[_c('ol',_vm._l((_vm.explanationList),function(item){return _c('li',[_vm._v(_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }